import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class FullwidthContent {
	constructor() {
		this.container = document.querySelector('[data-fullwidth-animate]')
		if (!this.container) return
		this.#init()
	}

	#init() {
		const mm = gsap.matchMedia()

		mm.add('(min-width: 1024px)', () => {
			const inner = this.container.querySelector('[data-hero-inner]')
			const content = this.container.querySelector('[data-hero-content]')
			const media = this.container.querySelector('[data-hero-media]')
			if (!inner) return

			const startScale = 0.7
			const counterScale = 1 / startScale

			const sharedTrigger = {
				trigger: this.container,
				start: 'top top',
				end: '50% top',
				scrub: .5,
			}

			gsap.fromTo(
				inner,
				{
					scale: startScale,
					y: '3vh',
					transformOrigin: 'center top',
				},
				{
					scale: 1,
					y: 0,
					ease: 'none',
					scrollTrigger: sharedTrigger,
				}
			)

			if (content) {
				gsap.fromTo(
					content,
					{ scale: counterScale, transformOrigin: 'left bottom' },
					{
						scale: 1,
						ease: 'none',
						scrollTrigger: { ...sharedTrigger },
					}
				)
			}

			if (media) {
				gsap.fromTo(
					media,
					{
						scale: 2,
						y: '-15%',
					},
					{
						scale: 1,
						y: '0%',
						ease: 'none',
						scrollTrigger: { ...sharedTrigger },
					}
				)
			}
		})
	}
}